var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/ButtonUpsell/ButtonUpsellTemplate.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from '@zillow/constellation';
import { useYieldCallback } from '@zillow/yield-callback';
import { appendQueryParameter } from '../../../../../utils/stringUtils';

var ButtonUpsellTemplate = function ButtonUpsellTemplate(_ref) {
  var actionText = _ref.actionText,
      actionSubText = _ref.actionSubText,
      actionLink = _ref.actionLink,
      trackingParameter = _ref.trackingParameter,
      zpid = _ref.zpid,
      buttonType = _ref.buttonType,
      target = _ref.target,
      onClickProp = _ref.onClick;
  var formattedActionLink = appendQueryParameter(actionLink, trackingParameter, zpid);
  var onClick = useYieldCallback(function (e) {
    onClickProp(e);
    window.open(formattedActionLink, target);
  });
  return /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    buttonType: buttonType,
    onClick: onClick,
    style: {
      flexDirection: 'column'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }, actionText, actionSubText && /*#__PURE__*/React.createElement(Text, {
    fontColor: "textWhite",
    fontType: "finePrint",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 17
    }
  }, actionSubText));
};

ButtonUpsellTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  actionText: PropTypes.string.isRequired,
  actionSubText: PropTypes.string,
  actionLink: PropTypes.string.isRequired,
  buttonType: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  trackingParameter: PropTypes.string,
  zpid: PropTypes.string
} : {};
ButtonUpsellTemplate.defaultProps = {
  onClick: function onClick() {},
  trackingParameter: '',
  zpid: '',
  buttonType: 'primary',
  target: '_blank',
  actionSubText: ''
};
export default ButtonUpsellTemplate;